import React from 'react';
import ReactDOM from 'react-dom';
import firebase from '@firebase/app';

import App from './components/App';
import auth from './auth';
import history from './history';
import routes from './routes';

firebase.initializeApp({
  apiKey: 'AIzaSyAlFcefPSX2-ZFLdz4NhWEgoEVhYu-RPq0',
  authDomain: 'lacroix-3965c.firebaseapp.com',
  databaseURL: 'https://lacroix-3965c.firebaseio.com',
  projectId: 'lacroix-3965c',
  storageBucket: 'lacroix-3965c.appspot.com',
  messagingSenderId: '389243487836',
});

const render = props =>
  new Promise((resolve, reject) => {
    try {
      ReactDOM.render(
        <App {...props} />,
        document.getElementById('root'),
        resolve(props),
      );
    } catch (err) {
      reject(err);
    }
  });

const resolve = promise =>
  promise.then(({ user, location }) =>
    routes.resolve({
      pathname: location.pathname,
      location,
      user,
      render,
    }),
  );

let promise;

auth.onAuthStateChanged(user => {
  if (!promise) {
    promise = Promise.resolve({ user, location: history.location });
    history.listen(location => {
      promise = resolve(promise.then(x => ({ ...x, location })));
    });
  }
  promise = resolve(promise.then(x => ({ ...x, user })));
});



// WEBPACK FOOTER //
// ./src/index.js